
import breadcrumb from "../library/breadcrumb.vue"
import { getSimilarList } from "../api/gateway"
import similarWare from "../components/similarWare/similarWare"
import getCartNumMixin from "@/mixins/getCartNum"
import { Logger } from "@/plugins/logger"
import { getRequestHeaders } from "@/utils/utils"
export default {
  name: "Similar",
  components: {
    similarWare,
    breadcrumb
  },
  mixins: [getCartNumMixin],
  validate({ query }) {
    return query.skuId
  },
  props: {
    configs: {
      type: Object,
      default: () => {}
    }
  },
  async asyncData({ route, req, store, error }) {
    try {
      const { data } = await getSimilarList(
        {
          param: {
            skuId: route.query.skuId
          },
          comm: {}
        },
        {
          loading: true,
          headers: getRequestHeaders({ req, store })
        }
      )
      return {
        similarList: data.similarList || []
      }
    } catch (err) {
      Logger.error("同类商品推荐", err)
      error({
        statusCode: 500,
        message: "Internal Server Error"
      })
    }
  },
  data() {
    return {
      similarList: [],
      breadcrumbData: [
        {
          name: this.$t("common.home"),
          path: "/"
        },
        {
          name: this.$t("common.similarProducts")
        }
      ]
    }
  },
  head() {
    return {
      title: this.pageTitle
    }
  },
  computed: {
    hasWare() {
      return this.wareList.length > 0
    }
  }
}
